<template  src='./TarjetaMiniaturaExpansible.html'>
    
</template>
<script>
import { consultarInformacionTarjetaEspecifica } from '../../apiService/request/CrudFormulario';
import { consultarEstructuraCuestionarioPorId } from '../../apiService/request/CrudSeguimiento';
import TarjetasNuevasMomento from "../TarjetasNuevasMomento/TrajetasNuevasMomento";
export default {
    data() {
        return {
            banderaAbrirTarjeta:false,
            informacionFormularioEspecifico:[],
            deshabilitado : true,
        }
    },
    components:{
        TarjetasNuevasMomento
    },
    created() {      
    },
    props: {
    // deshabilitado:
    // {
    //   type: Boolean,
    //   default: true
    // },
        tarjetaFormularioMomento:{
            required: true
        }
    },
    methods: {
        abrirTarjetaFormularioMomento(formulario_id, nombreCategoria){          
            this.banderaAbrirTarjeta=!this.banderaAbrirTarjeta
            this.InformacionTarjetaEspecifica(formulario_id,nombreCategoria)
            // serverBus.$emit("abrirTarjetaFormulario", formulario_id, nombreCategoria); 
        },        
        async InformacionTarjetaEspecifica(formulario_id,nombreCategoria){            
            try{
                const respuesta = await consultarEstructuraCuestionarioPorId(formulario_id,'formularios',nombreCategoria)
             console.log('respuesta',respuesta.data.data.variables);  
                this.$store.dispatch('setVariablesFormularios',respuesta.data.data.variables)
                this.$store.dispatch('setNombreFormulario',respuesta.data.data.key)
                this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
                // this.informacionFormularioEspecifico=respuesta.data.data.variables;
            }
            catch (err){
            }
        }, 
    },
}
</script>
<style  src='./TarjetaMiniaturaExpansible.scss' lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/TarjetaMiniaturaExpansible/TarjetaMiniaturaExpansible.vue